/* drop */
/*--------------------------------------------------------------------------------*/
export const menu = (drop: HTMLElement) => {
    const dropBtn = drop.querySelector<HTMLButtonElement>('.drop-btn');
    const content = drop.querySelector<HTMLElement>('.drop-content');
    if (!dropBtn || !content) return;
    setBtnEvent(dropBtn, content);
};
/*--------------------------------------------------------------------------------*/
export const select = (
    drop: HTMLElement,
    icon: string,
    callBack: (value: string, text: string) => void,
) => {
    const dropBtn = drop.querySelector<HTMLButtonElement>('.drop-btn');
    const content = drop.querySelector<HTMLElement>('.drop-content');
    if (!dropBtn || !content) return;
    setBtnEvent(dropBtn, content);
    update(drop, icon, callBack);
};
/*--------------------------------------------------------------------------------*/
export const update = (
    drop: HTMLElement,
    icon: string,
    callBack: (value: string, text: string) => void,
) => {
    const select = drop.querySelector<HTMLSelectElement>('select');
    const content = drop.querySelector<HTMLElement>('.drop-content');
    if (!select || !content) return;
    let elmIcon = '';
    if (icon) elmIcon = `<span style="margin-right: 6px;">${icon}</span>`;
    // select to menu
    content.innerHTML = '';
    const option = select.querySelectorAll<HTMLOptionElement>('option');
    option.forEach(opt => {
        const item = document.createElement('a');
        item.innerHTML = `${elmIcon}${opt.text}`;
        content.appendChild(item);
        // drop click
        item.onclick = () => {
            opt.selected = true;
            clearSelected();
            if (callBack) {
                callBack(opt.value, opt.text);
            }
        };
    });
    // clear selected
    const clearSelected = () => {
        const index = select.selectedIndex;
        const list = content.querySelectorAll<HTMLAnchorElement>('a');
        list.forEach((el, i) => {
            if (i == index) {
                el.classList.add('selected');
            } else {
                el.classList.remove('selected');
            }
        });
    };
    clearSelected();
};
/*--------------------------------------------------------------------------------*/
const setBtnEvent = (btn: HTMLButtonElement, content: HTMLElement) => {
    btn.onclick = () => {
        if (content.style.display == 'block') {
            content.style.animation = 'fade-out 0.4s forwards';
            content.onanimationend = () => {
                content.style.animation = '';
                content.style.display = '';
            };
        } else {
            clear();
            content.style.animation = 'fade-in 0.4s forwards';
            content.style.display = 'block';
            content.onanimationend = () => {
                content.style.animation = '';
            };
        }
    };
};
/*--------------------------------------------------------------------------------*/
export const clear = () => {
    const drop = document.querySelectorAll<HTMLElement>('.drop-content');
    drop.forEach(el => {
        if (el.style.display == 'block') {
            el.style.animation = 'fade-out 0.4s forwards';
            el.onanimationend = () => {
                el.style.animation = '';
                el.style.display = '';
            };
        }
    });
};
window.addEventListener('click', (e) => {
    if (!(<HTMLElement>e.target).matches('.drop-btn')) clear();
});
/*--------------------------------------------------------------------------------*/
